import { SGSKeyboardDatePicker, SGSKeyboardDatePickerProps } from 'components';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = Partial<SGSKeyboardDatePickerProps> & {
    label?: string;
    name?: string;
};

const SGSFormDate: React.FC<Props> = ({ name, label, ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    return (
        <Controller
            {...props}
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const handleDateChange = (date: Date | null) => {
                    if (date) {
                        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                        utcDate.setHours(4, 0, 0);
                        return utcDate;
                    } else {
                        return date;
                    }
                };

                return (
                    <SGSKeyboardDatePicker
                        {...props}
                        clearable
                        name={name}
                        id={name}
                        value={value || null}
                        onChange={(date) => onChange(handleDateChange(date))}
                        format="dd/MM/yyyy"
                        label={t(label as string)}
                        inputVariant={props.inputVariant}
                        error={!!error}
                        helperText={error?.message || ''}
                    />
                );
            }}
        />
    );
};

export default SGSFormDate;
